import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import './selector.scss';

class Selector extends Component {
  render() {
    const { match, history, organisations, path } = this.props;

    return (
      <select className="organisation-select" value={match.params.organisationId} onChange={(e) => history.push(`/organisations/${e.target.value}${path}`)} >
        {
            organisations.length === 1 ?
            <option key={organisations[0].id} value={organisations[0].id}>{organisations[0].name}</option>
            :
            organisations.map(organisation =><option key={organisation.id} value={organisation.id}>{organisation.name}</option>)
        }
      </select>
    );
  }
}

export default withRouter(connect(
  ({ organisations }, ownprops) => {
    return {
      organisations: organisations.data,
      path: ownprops.path
    }
  }
)(Selector));



// WEBPACK FOOTER //
// ./src/components/organisations/Selector.js